import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import user from './user';
import auth from './auth';
import student from './student';
import error from './error';

export default combineReducers({
    routing: routerReducer,
    user,
    auth,
    student,
    error,
});
